import { CircleNode, CircleNodeModel, h } from '@logicflow/core';
import { getEventIconElements } from './eventIcons';
import { getThemeStyle } from '../theme';
import { initLabelOffset } from './textUtils';

class BoundaryEventView extends CircleNode {
  getShape() {
    const { model } = this.props;
    const { x, y, r, properties } = model;
    const style = model.getNodeStyle();
    const trigger = properties.trigger || '';
    const isInterrupting = properties.isInterrupting;
    const dash = isInterrupting === false ? { strokeDasharray: '4,2.5' } : {};

    return h('g', {}, [
      // Outer circle
      h('circle', { cx: x, cy: y, r, ...style, ...dash }),
      // Inner circle (double border like intermediate)
      h('circle', {
        cx: x, cy: y, r: r - 3,
        fill: 'none', stroke: style.stroke, strokeWidth: 1, ...dash,
      }),
      ...getEventIconElements(h, x, y, trigger, false, style.stroke, 0.83),
    ]);
  }
}

class BoundaryEventModel extends CircleNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.r = 15;
    initLabelOffset(this, data, this.r + 14);
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'boundaryEvent');
    style.stroke = t.stroke || '#fa541c';
    style.strokeWidth = t.strokeWidth ?? 1.5;
    style.fill = t.fill || '#fff2e8';
    return style;
  }
}

export const BoundaryEvent = {
  type: 'epx:BoundaryEvent',
  view: BoundaryEventView,
  model: BoundaryEventModel,
};
